export default {
	"medium": "1600",
	"tabled": "1099",
	"mobile": "599",
}

export function slideUp(target, duration = 500) {

	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.boxSizing = 'border-box';
	target.style.height = target.offsetHeight + 'px';
	target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	window.setTimeout(() => {
		target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
		//alert("!");
	}, duration);
}
export function slideDown(target, duration = 500) {

	target.style.removeProperty('display');
	let display = window.getComputedStyle(target).display;
	if (display === 'none') display = 'block';
	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = 'border-box';
	target.style.transitionProperty = "height, margin, padding";
	target.style.transitionDuration = duration + 'ms';
	target.style.height = height + 'px';
	target.style.removeProperty('padding-top');
	target.style.removeProperty('padding-bottom');
	target.style.removeProperty('margin-top');
	target.style.removeProperty('margin-bottom');
	window.setTimeout(() => {
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
	}, duration);
}
export function slideToggle(target, duration = 500) {
	if (window.getComputedStyle(target).display === 'none') {
		return slideDown(target, duration);
	} else {
		return slideUp(target, duration);
	}
}

export function getCookie(e, t = !1) {
	if (!e) return;
	let n = document.cookie.match(
		new RegExp(
			"(?:^|; )" +
			e.replace(/([.$?*|{}()\[\]\\\/+^])/g, "\\$1") +
			"=([^;]*)"
		)
	);
	if (n) {
		let e = decodeURIComponent(n[1]);
		if (t)
			try {
				return JSON.parse(e);
			} catch (e) { }
		return e;
	}
}
export function setCookie(e, t, n = { path: "/" }) {
	if (!e) return;
	(n = n || {}).expires instanceof Date &&
		(n.expires = n.expires.toUTCString()),
		t instanceof Object && (t = JSON.stringify(t));
	let o = encodeURIComponent(e) + "=" + encodeURIComponent(t);
	for (let e in n) {
		o += "; " + e;
		let t = n[e];
		!0 !== t && (o += "=" + t);
	}
	document.cookie = o;
}
export function deleteCookie(e) {
	setCookie(e, null, { expires: new Date(), path: "/" });
}
